import React,{ useState, useEffect, useRef} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import api from '../../../interceptor/axios';
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade,Navigation,Thumbs,Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import fav1 from '../../../assets/images/favorite/01.jpg'
SwiperCore.use([EffectFade,Navigation,Thumbs,Pagination]);


const Ayuda = () => {
    const baseUrl = process.env.REACT_APP_ESTATICOS_URL + 'videos/';
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);
    const [videos, setVideos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubcategorias] = useState([]);

    useEffect(() => {
        api.post(process.env.REACT_APP_REST_URL + 'ayuda.php', {})
            .then(response => {
                if (response.data.success !== true) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
                } else {
                    let ultimoIdCat = 0;
                    let ultimoIdSubcat = 0;
                    for (let i = 0; i < response.data.videos.length; i++) {
                        if (response.data.videos[i].id_cat !== ultimoIdCat) {
                            ultimoIdCat = response.data.videos[i].id_cat;
                            setCategorias(categorias => [...categorias, { id: response.data.videos[i].id_cat, nombre: response.data.videos[i].nombre_cat }]);
                        }
                        if (response.data.videos[i].id_sub !== ultimoIdSubcat) {
                            ultimoIdSubcat = response.data.videos[i].id_sub;
                            setSubcategorias(subcategorias => [...subcategorias, { id: response.data.videos[i].id_sub, nombre: response.data.videos[i].nombre_sub, id_cat: response.data.videos[i].id_cat }]);
                        }
                    }                 
                    setVideos(response.data.videos);
                    setLoading(false);
                }
            })
            .catch(error => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
            });
    }, []);


    if(loading){
    
            return (
                <>
                <Toast ref={toast} />
                <div className="main-content">
                    <Container fluid>
                        <Row>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                        </Row>
                         <Row style={{marginTop: '20px'}}>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                            <Col sm="12" md="4" className="overflow-hidden">
                                <div className="d-flex flex-column">
                                    <Skeleton width="100%" height="250px" />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                </>
            );
    
        } else {
    
            return (
                <>
                <Toast ref={toast} />

                <div className="main-content">
                    {categorias.map((cat) => (
                        <Container fluid key={cat.id} style={{marginTop: '20px'}}>                      
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>{cat.nombre}</h4>
                                </div>
                                {subcategorias.filter(subcat => subcat.id_cat === cat.id).map((subcat) => (
                                    <>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h5>{subcat.nombre}</h5>
                                        </div>
                                        <div key={subcat.id}>
                                            <Row>
                                                {videos
                                                .filter(video => video.id_sub === subcat.id)
                                                .map((video, indexVideo) => (

                                                    <Col sm="4">
                                                        <div className="video-title">{video.titulo}</div>
                                                        <div className="embed-responsive embed-responsive-16by9">
                                                            <video key={`${baseUrl}${video.slug}`} width="100%" controls controlsList="nodownload">
                                                                <source src={`${baseUrl}${video.slug}`} type="video/mp4" />
                                                            </video>
                                                        </div>
                                                        <p>{video.descripcion}</p>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    </>
                                ))}
                        </Container>
                    ))}
                </div>
                
          
                
                </>
            );
        }
};

export default Ayuda;